import Api from "./Api";
import Utils from "../utilities/Utils";
import {
  ArticleCollection,
  ArticleCollectionIcon,
  HelpCenter,
  Locale,
} from "../types";
import SearchHelper from "../helpers/SearchHelper";

export default class ArticleCollectionsController extends Api {
  static getArticleCollections(helpCenterId: string, params: object) {
    return fetch(
      `/api/help_centers/${helpCenterId}/collections?${SearchHelper.getQueryString(
        params
      )}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.token,
        },
        credentials: "same-origin",
      }
    ).then((res) => res.json());
  }

  static getArticleCollection(helpCenterId: string, id: string) {
    return fetch(`/api/help_centers/${helpCenterId}/collections/${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static create(helpCenterId: string, articleCollection: ArticleCollection) {
    return fetch(`/api/help_centers/${helpCenterId}/collections`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ article_collection: articleCollection }),
    }).then((res) => res.json());
  }

  static update(helpCenterId: string, articleCollection: ArticleCollection) {
    return fetch(
      `/api/help_centers/${helpCenterId}/collections/${articleCollection.id}`,
      {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.token,
        },
        credentials: "same-origin",
        body: JSON.stringify({ article_collection: articleCollection }),
      }
    ).then((res) => res.json());
  }

  static delete(helpCenterId: string, id: string) {
    return fetch(`/api/help_centers/${helpCenterId}/collections/${id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static getForm(
    helpCenterId: string,
    params: { id?: string }
  ): Promise<{
    default_locale: Locale;
    article_collection: ArticleCollection;
    icon_categories: string[];
    article_collection_icons: ArticleCollectionIcon[];
  }> {
    return fetch(
      `/api/help_centers/${helpCenterId}/collections/form?${Utils.encodeQueryData(
        params
      )}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.token,
        },
        credentials: "same-origin",
      }
    ).then((res) => res.json());
  }
}
